import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  AppGridSetting,
  AppGridSettingDto,
  AppGridSettingInitialState,
} from "../../../../models/app/AppGridModels";
import { axiosBaseQuery } from "../../../../api/agent";
import { createApi } from "@reduxjs/toolkit/dist/query/react";

export const AppGridSlice = createSlice({
  name: "AppGridSlice",
  initialState: AppGridSettingInitialState,
  reducers: {
    addGridSetting: (
      state,
      action: PayloadAction<{ setting: AppGridSetting }>
    ) => {
      const { setting } = action.payload;
      const existingIndex = state.setting.findIndex(
        (x) => x.gridId === setting.gridId
      );
      if (existingIndex !== -1) {
        state.setting[existingIndex] = setting;
      } else {
        state.setting.push(setting);
      }
    },
    removeGridSetting: (state) => {
      state.setting = [];
    },
    setHasUnsavedChanges: (state, action: PayloadAction<boolean>) => {
      state.hasUnsavedChanges = action.payload;
    },
  },
});

export const appGridSettingApi = createApi({
  reducerPath: "appGridSettingApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    addAppGridSetting: build.mutation<any, { data: AppGridSettingDto }>({
      query: ({ data }) => ({
        url: `api/TargetWebSetting/AddAppGridSetting`,
        method: "post",
        data: data,
      }),
    }),
  }),
});

export const { useAddAppGridSettingMutation } = appGridSettingApi;

export const { addGridSetting, removeGridSetting, setHasUnsavedChanges } =
  AppGridSlice.actions;
export const AppGridReducer = AppGridSlice.reducer;
